import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-bg',
  templateUrl: './bg.component.html',
  styleUrls: ['./bg.component.css']
})
export class BgComponent {
  @Input() bgClass: string;
  
}



// WEBPACK FOOTER //
// ./src/app/bg/bg.component.ts